/* globals $:false */
/* globals console:false */

(function () {
    'use strict';

    let menuActive = false;
    let scrollLocation = 0;
    let currentLocation = 0;


    window.addEventListener("scroll", function (event) {
        scrollLocation = this.scrollY;
    });

    $(document).ready(function () {
        let overlayContainer = $('#nav-menu');

        $('#nav-open').on('click', function (event) {
            event.preventDefault();

            currentLocation = scrollLocation;

            $('body').css('overflow', 'hidden');

            navOpen();
        });

        $('#nav-close').on('click', function (event) {
            event.preventDefault();

            $('body').css('overflow', 'auto');

            navClose();
        });
    });

    $(window).resize(function () {
        resize();
    });

    function navOpen() {
        // $('#nav-menu').removeClass('hide').addClass('show').css({'opacity': 1});
        $('#nav-menu').removeClass('hide').addClass('show').css({'opacity': 1});

        resize();
        // $('#menu-header-row, #menu-list-row').css({'opacity': 1 });
    }

    function navClose() {
        $('#nav-menu').removeClass('show').addClass('hide').css({'opacity': 0});
        // $('#menu-header-row, #menu-list-row').css({'opacity': 0 });
    }

    function resize() {
        let heightWindow = $(window).height();
        //
        // let header = $('#menu-header-row');
        // let heightHeader = header.height();
        //
        // let menu = $('#menu-list-row');
        // let heightMenu = menu.height();
        //
        // let margin = (heightWindow - (heightHeader + heightMenu)) / 7;
        // let marginTop = margin * 3;
        //
        // let totalHeight = heightHeader + heightMenu + 50 + 50;
        //
        // if (totalHeight <= heightWindow) {
        //     menu.css('marginTop', marginTop + 'px');
        // } else {
        //
        // }
    }
}());